import React from 'react';
import { nestedMenuItemsFromObject } from './nestedMenuItemsFromObject';
import Button, { ButtonProps } from '@mui/material/Button';
import Menu, { MenuProps } from '@mui/material/Menu';
import { ChevronDown } from '../icons/ChevronDown';
import { MenuItemData } from '..';
import '../mui-nested-menu.scss';

interface NestedDropdownProps {
    children?: React.ReactNode;
    menuItemsData?: MenuItemData;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    ButtonProps?: Partial<ButtonProps>;
    MenuProps?: Partial<MenuProps>;
    index: number;
}

export const NestedDropdown = React.forwardRef<HTMLDivElement | null, NestedDropdownProps>((props, ref) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const { menuItemsData: data, onClick, ButtonProps, MenuProps, index, ...rest } = props;

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(e.currentTarget);
        if (onClick) {
            onClick(e);
        }
    };

    const handleClose = () => setAnchorEl(null);

    const menuItems = nestedMenuItemsFromObject({
        menuItemsData: data.items,
        parent: data,
        isOpen: open,
        handleClose,
        index,
    });

    return (
        <div ref={ref} {...rest}>
            <Button className="Nested-Button" onClick={handleClick} endIcon={<ChevronDown />} {...ButtonProps}>
                {data.label}
            </Button>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose} {...MenuProps}>
                {menuItems}
            </Menu>
        </div>
    );
});
